export default __webpack_public_path__ + "static/media/AK_Fahrrad_Webseite.611dc73f.jpg";